import {flow, includes, makeGet, negate} from '@yandex-delivery/utils'

import {TicketStateResponse} from '../../../repo/cargo-crm/types'

const ticketGet = makeGet<TicketStateResponse>()
const getAwaitedSteps = ticketGet('progress.awaited_steps')

export const getNextStepToken = ticketGet('next_step.token')
export const getClientID = ticketGet('forms.company_created_form.corp_client_id')
export const getCardID = ticketGet('forms.card_bound_form.card_id')
export const isNotCompanyInfoFormStep: (r: TicketStateResponse) => boolean = flow(
  getAwaitedSteps,
  negate(includes('company_info_form')),
)
export const isNotCardBoundFormStep: (r: TicketStateResponse) => boolean = flow(
  getAwaitedSteps,
  negate(includes('card_bound_form')),
)
